<template>
  <div class="container-wrap">
    <w-header />
    <router-view />
    <w-footer v-if="isShowFooter" />
  </div>
</template>

<script>
  import WHeader from '@/views/layout/components/WHeader'
  import WFooter from '@/views/layout/components/WFooter'
  export default {
    components: {
      WHeader,
      WFooter
    },
    computed: {
      isShowFooter() {
        if (['/login', '/register', '/settled'].includes(this.$route.path)) {
          return false
        } else {
          return true
        }
      }
    }
  }

</script>

<style lang="scss" scoped>

</style>
